import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAwI9XRzQrKfWMIMoq-jV0C-DhVtOVAdSE",
  authDomain: "home-e94dc.firebaseapp.com",
  databaseURL: "https://home-e94dc.firebaseio.com",
  projectId: "home-e94dc",
  storageBucket: "home-e94dc.appspot.com",
  messagingSenderId: "364220114241",
  appId: "1:364220114241:web:661fe259e708a3c93bedc0"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
export const db = firebase.firestore();
